import { Subscriber } from '@app/models/subscriber.model';
import { CLIENT_ID } from './client.model';
import { Area } from './area.model';

export type CLUB_ID = string | number;

export abstract class AreaInputBase {
  client_id: CLIENT_ID = NaN;
  name: string = '';
}

export class SubscriptionType {
  id?: number = NaN;
  club_id?: number = NaN;
  name: string = '';
  rate: number = NaN;
}

export class Club {
  id: CLUB_ID;
  client_id: CLIENT_ID;
  name: string;
  image?: string | null;
  creation_time: string;
  areas?: string[];
  subscribers: Array<Subscriber>;
  subscriptionTypes: SubscriptionType[];
}

export class CreateClubInput extends AreaInputBase {
  areas?: Area[] = [];
  subscription_types: SubscriptionType[] = [];
  image?: string = '';
}

export class UpdateClubInput extends AreaInputBase {
  id: CLUB_ID = NaN;
  creation_time?: string = '';
  areas?: Area[] = [];
  image?: string = '';
  parent_id?: number[] = [];
}

export class FetchClubInput extends AreaInputBase {
  id: CLUB_ID = NaN;
  parent_id?: number[] = [];
}

export class UpdateClubInputWithSubscriptionTypes extends UpdateClubInput {
  subscription_types: SubscriptionType[] = [];
}
